<template>
    <v-card width="auto" tile>
        <v-form ref="form">
            <v-card-text class="pa-2">
              <v-row dense>
                <v-col cols="12">
                    <v-text-field
                    label="Nombre Plaza"
                    v-model="model.nombre"
                    :rules="fieldRequired"
                    outlined
                    dense />
                </v-col>

                <v-col cols="12">
                    <v-text-field
                    v-model="model.registro_patronal"
                    label="Registro Patronal"
                    outlined
                    dense
                    :rules="fieldRequired" />
                </v-col>

                <v-col cols="6">
                    <v-row dense>
                      <v-col cols="12">
                        <v-select
                          v-model="model.zona_id"
                          label="Zona"
                          :items="zonas"
                          :rules="fieldRequired"
                          item-text="nombre"
                          item-value="id"
                          @change="SelectedPuestos"
                          outlined
                          dense>
                        </v-select>
                      </v-col>
                      <v-col cols="12">
                        <SelectedGroupDinamicField :itemAction="selectTipoPuesto" :on-success="actionFieldData"/>
                      </v-col>

                      <v-col cols="12">
                        <v-select
                          label="Puesto"
                          v-model="model.puesto_id"
                          :items="puestos"
                          :rules="fieldRequired"
                          item-text="nombre"
                          item-value="id"
                          @change="SelectedCategorias"
                          outlined
                          dense>
                        </v-select>
                      </v-col>

                      <v-col cols="12">
                        <SelectedGroupDinamicField :itemAction="field" :on-success="actionFieldData" :showItems="field.items"/>
                      </v-col>
                    </v-row>
                </v-col>

                <v-col cols="6">
                  <v-row dense>
                    <v-col cols="12">
                      <v-select
                        v-model="model.clave_regimen"
                        label="Clave Regimen"
                        :items="clvRegimen"
                        :rules="fieldRequired"
                        item-text="nombre"
                        item-value="clave"
                        outlined
                        dense>
                      </v-select>
                    </v-col>

                    <v-col cols="6">
                      <v-select
                        v-model="model.tipo_contrato"
                        label="Tipo Contrato"
                        :items="tipoContrato"
                        :rules="fieldRequired"
                        item-text="nombre"
                        item-value="clave"
                        outlined
                        dense>
                      </v-select>
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        v-model="model.tipo_jornada"
                        label="Tipo Jornada"
                        :items="tipoJornada"
                        :rules="fieldRequired"
                        item-text="nombre"
                        item-value="clave"
                        outlined
                        dense>
                      </v-select>
                    </v-col>

                    <v-col cols="6">
                      <v-select
                        v-model="model.clave_riesgo"
                        label="Clave Riesgo"
                        :items="clvRiesgo"
                        :rules="fieldRequired"
                        item-text="nombre"
                        item-value="clave"
                        outlined
                        dense>
                      </v-select>
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        v-model="model.periodicidad"
                        label="Periocidad"
                        :items="periocidad"
                        :rules="fieldRequired"
                        item-text="nombre"
                        item-value="clave"
                        outlined
                        dense>
                      </v-select>
                    </v-col>

                    <v-col cols="12">
                      <v-select
                        v-model="model.origen_registro"
                        :items="origenRiesgo"
                        :rules="fieldRequired"
                        label="Origen Registro"
                        item-text="nombre"
                        item-value="clave"
                        outlined
                        dense>
                      </v-select>

                      <v-text-field
                        v-model.number="model.total"
                        label="Plazas Disponibles"
                        :rules="fieldRequired"
                        type="number"
                        outlined
                        dense />
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="6">
                  <v-card outlined min-height="270">
                    <v-card-title>Agregar Nivel de Sueldo</v-card-title>
                    <v-card-text>
                      <v-col cols="12">
                        <SelectedDinamicField :itemAction="selectedPeriodos" :on-success="actionFieldData" />
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          v-model="model.nivel_id"
                          label="Nivel"
                          :items="niveles"
                          :rules="fieldRequired"
                          :item-text="itemText"
                          item-value="id"
                          outlined
                          dense>
                        </v-select>
                      </v-col>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="6">
                  <v-card outlined min-height="270">
                    <v-card-title>Agregar Complemento</v-card-title>
                    <v-card-text>
                      <v-col cols="12">
                        <v-radio-group class="pa-0 ma-0" v-model="model.configuraciones.complemento" row>
                          <v-radio label="SI" value="si"></v-radio>
                          <v-radio label="NO" value="no"></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model.number="model.configuraciones.importe_complemento"
                          label="Importe Complemento"
                          type="number"
                          outlined
                          dense />
                      </v-col>
                    </v-card-text>
                  </v-card>
                </v-col>

                <!--
                  <v-col cols="10">
                    <v-text-field
                      v-model="Sueldo"
                      label="Sueldo Asignado"
                      class="black--text"
                      readonly
                      outlined
                      dense />
                  </v-col>
                -->
              </v-row>

              <v-alert type="error" v-if="show">
                {{message}}
              </v-alert>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-end>
                <v-btn class="red darken-1 mr-3" dark @click="onCancel">Cancelar</v-btn>
                <v-btn class="green darken-1 mr-3" dark @click="save"> Guardar</v-btn>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
import SelectedGroupDinamicField from '@/components/fields/SelectedGroupDinamicField'
import SelectedDinamicField from '@/components/fields/SelectedDinamicField'
export default {
  name: 'PlazaFormCreate',
  mixins: [Validate],
  props: ['model', 'onSuccess', 'onCancel'],
  data: () => ({
    message: '',
    show: false,
    position: 0,
    zonas: [],
    niveles: [],
    tipo_plazas: [],
    puestos: [],
    categorias: [],

    tipoContrato: [
      { clave: '01', nombre: 'Contrato de trabajo por tiempo indeterminado' },
      { clave: '02', nombre: 'Contrato de trabajo para obra determinada' },
      { clave: '03', nombre: 'Contrato de trabajo por tiempo determinado' },
      { clave: '04', nombre: 'Contrato de trabajo por temporada' },
      { clave: '05', nombre: 'Contrato de trabajo sujeto a prueba' },
      { clave: '06', nombre: 'Contrato de trabajo con capacitación inicial' },
      { clave: '07', nombre: 'Modalidad de contratación por pago de hora laborada' },
      { clave: '08', nombre: 'Modalidad de trabajo por comisión laboral' },
      { clave: '09', nombre: 'Modalidades de contratación donde no existe relación de trabajo' },
      { clave: '10', nombre: 'Jubilación, pensión, retiro' },
      { clave: '99', nombre: 'Otro contrato' }
    ],
    tipoJornada: [
      { clave: '01', nombre: 'Diurna' },
      { clave: '02', nombre: 'Nocturna' },
      { clave: '03', nombre: 'Mixta' },
      { clave: '04', nombre: 'Por hora' },
      { clave: '05', nombre: 'Reducida' },
      { clave: '06', nombre: 'Continuada' },
      { clave: '07', nombre: 'Partida' },
      { clave: '08', nombre: 'Por turnos' },
      { clave: '99', nombre: 'Otra Jornada' }
    ],
    clvRiesgo: [
      { clave: '01', nombre: 'Clase I' },
      { clave: '02', nombre: 'Clase II' },
      { clave: '03', nombre: 'Clase III' },
      { clave: '04', nombre: 'Clase IV' },
      { clave: '05', nombre: 'Clase V' },
      { clave: '99', nombre: 'No aplica' }
    ],
    periocidad: [
      { clave: '01', nombre: 'Diario' },
      { clave: '02', nombre: 'Semanal' },
      { clave: '03', nombre: 'Catorcenal' },
      { clave: '04', nombre: 'Quincenal' },
      { clave: '05', nombre: 'Mensual' },
      { clave: '06', nombre: 'Bimestral' },
      { clave: '07', nombre: 'Unidad obra' },
      { clave: '08', nombre: 'Comisión' },
      { clave: '09', nombre: 'Precio alzado' },
      { clave: '10', nombre: 'Decenal' },
      { clave: '99', nombre: 'Otra Periodicidad' }
    ],
    clvRegimen: [
      { clave: '02', nombre: 'Sueldos' },
      { clave: '03', nombre: 'Jubilados' },
      { clave: '04', nombre: 'Pensionados' },
      { clave: '05', nombre: 'Asimilados Miembros Sociedades Cooperativas Produccion' },
      { clave: '06', nombre: 'Asimilados Integrantes Sociedades Asociaciones Civiles' },
      { clave: '07', nombre: 'Asimilados Miembros consejos' },
      { clave: '08', nombre: 'Asimilados comisionistas' },
      { clave: '09', nombre: 'Asimilados Honorarios' },
      { clave: '10', nombre: 'Asimilados acciones' },
      { clave: '11', nombre: 'Asimilados otros' },
      { clave: '12', nombre: 'Jubilados o Pensionados' },
      { clave: '99', nombre: 'Otro Regimen' }
    ],
    origenRiesgo: [
      { clave: 'IP', nombre: 'Ingresos propios' },
      { clave: 'IF', nombre: 'Ingreso federales' },
      { clave: 'IM', nombre: 'Ingresos mixtos' }
    ],
    field: {
      field: 'selectGroupDataServer',
      name: 'Categoria',
      nameid: 'categoria_id',
      url: '',
      items: [],
      rules: true,
      cols: 12
    },
    selectTipoPuesto: {
      field: 'selectGroupDataServer',
      name: 'Tipo Plaza',
      nameid: 'tipo_plaza_id',
      url: '/nomina/config/tipo-plaza/show',
      items: [],
      sub: 'sub_tipo_plaza',
      rules: true,
      cols: 12
    },
    selectedPeriodos: {
      field: 'selectDataServer',
      name: 'Ejercicio',
      nameid: 'ejercicio_id',
      url: '/nomina/config/ejercicio/show',
      rules: true,
      default: true,
      cols: 12
    }
  }),
  components: {
    SelectedGroupDinamicField,
    SelectedDinamicField
  },
  mounted () {
    this.getUrl('POST/nomina/config/zonas/show')
  },
  methods: {
    ...mapActions(['postServiceListActionSecound']),
    actionFieldData (obj) {
      this.model[obj.id] = (obj.data === undefined) ? null : obj.data
      if (obj.id === 'ejercicio_id') {
        this.changesNivels(obj.data)
      }
    },
    itemText (item) {
      return `${item.nivel} Min: ${item.minimo} --- Max: ${item.maximo}`
    },
    save () {
      if (this.$refs.form.validate()) {
        this.show = false
        this.message = ''
        if (!this.model.ejercicio_id) {
          this.show = true
          this.message = 'Campos Ejercicio es obligatorio'
          return
        }
        this.onSuccess(this.model)
      } else {
        this.show = true
        this.message = 'Campos Obligatorios'
      }
    },
    getUrl (objet) {
      const router = this.get_urls[objet]
      this.postServiceListActionSecound({ url: router, data: {} })
    },
    SelectedPuestos (zonaId) {
      if (zonaId) {
        this.zonas.map(zona => {
          if (zona.id === zonaId) {
            this.puestos = []
            this.puestos.push(...zona.puestos)

            this.niveles = []
            zona.niveles.map(nivel => {
              if (nivel.ejercicio_id === this.model.ejercicio_id) {
                this.niveles.push(nivel)
              }
            })
            // this.niveles.push(...zona.niveles)
          }
        })
      }
    },
    SelectedCategorias (PuestoId) {
      if (PuestoId) {
        this.puestos.map(puesto => {
          if (puesto.id === PuestoId) {
            this.categorias = []
            this.categorias.push(...puesto.categorias)
            this.field.items = this.SubFamilias(puesto.categorias)
          }
        })
      }
    },
    SubFamilias (categorias) {
      const catgoriasSub = []
      categorias.map(item => {
        catgoriasSub.push(item)
        if (item.sub_categoria.length > 0) {
          item.sub_categoria.map(sub => {
            catgoriasSub.push(sub)
          })
        }
      })
      return catgoriasSub
    },
    changesNivels (ejercicio) {
      if (this.model.zona_id) {
        this.zonas.map(zona => {
          if (zona.id === this.model.zona_id) {
            this.niveles = []
            zona.niveles.map(nivel => {
              if (nivel.ejercicio_id === ejercicio) {
                this.niveles.push(nivel)
              }
            })
            // this.niveles.push(...zona.niveles)
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objectsSecound']),
    Sueldo () {
      if (this.model.tipo_plaza_id && this.model.nivel_id) {
        let p = {}
        let n = {}
        this.tipo_plazas.map(typePlaza => {
          if (typePlaza.id === this.model.tipo_plaza_id) {
            p = typePlaza
          }
        })
        this.niveles.map(nivel => {
          if (nivel.id === this.model.nivel_id) {
            n = nivel
          }
        })
        const configuracones = p.configuracion
        return n[configuracones.sueldo]
      }
      return 0
    }
  },
  watch: {
    get_objectsSecound (vals) {
      switch (this.position) {
        case 0:
          this.zonas = vals
          this.position = 1
          // this.getUrl('POST/nomina/config/tipo-plaza/show')
          break
        case 1:
          this.tipo_plazas = vals
          break
        case 3:
          this.categorias = vals
          break
      }
    }
  }

}
</script>

<style>

</style>
